<template>
  <div id="app">
    <l-top-bar></l-top-bar>
      <keep-alive>
      <router-view></router-view>
      </keep-alive>
    <l-footer-bar></l-footer-bar>
  </div>
</template>
<script>
export default{
  data(){
    return {
      animated: {
        'enter-active-class': 'animated',
        'leave-active-class': 'animated fadeOutLeft'
      }
    }
  }
}
</script>
<style lang="scss">

@keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeout {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}


.jump-enter{
  opacity: 0;
}
.jump-enter-to{
  opacity: 1;
}

.jump-enter-active{
  animation-name: fadein;
}

.jump-leave-active{
  animation-name: fadeout;
}

</style>
